module.exports = __webpack_public_path__ + "img/pattern-1.663ec921.svg";